var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { padding: "10px", height: "100%" } },
    [
      _c("vxe-toolbar", {
        attrs: { refresh: { query: _vm.refreshList }, custom: "" },
        scopedSlots: _vm._u([
          {
            key: "buttons",
            fn: function () {
              return [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      size: "small",
                      icon: "el-icon-plus",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.add()
                      },
                    },
                  },
                  [_vm._v("新建")]
                ),
                _vm.hasPermission("sys:dict:del")
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          type: "danger",
                          size: "small",
                          icon: "el-icon-delete",
                          disabled:
                            _vm.$refs.dictValueTable &&
                            _vm.$refs.dictValueTable.getCheckboxRecords()
                              .length === 0,
                          plain: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.del()
                          },
                        },
                      },
                      [_vm._v("删除")]
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "vxe-table",
        {
          ref: "dictValueTable",
          attrs: {
            border: "inner",
            "auto-resize": "",
            resizable: "",
            height: "auto",
            loading: _vm.loading,
            size: "small",
            "show-header-overflow": "",
            "show-overflow": "",
            "highlight-hover-row": "",
            "menu-config": {},
            "print-config": {},
            "import-config": {},
            "export-config": {},
            "sort-config": { remote: true },
            data: _vm.dataList,
            "checkbox-config": {},
          },
        },
        [
          _c("vxe-column", { attrs: { type: "seq", width: "40" } }),
          _c("vxe-column", { attrs: { type: "checkbox", width: "40px" } }),
          _c("vxe-column", {
            attrs: { field: "label", title: "标签" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm.hasPermission("sys:dict:edit")
                      ? _c(
                          "el-link",
                          {
                            attrs: { type: "primary", underline: false },
                            on: {
                              click: function ($event) {
                                return _vm.edit(scope.row.id)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.label))]
                        )
                      : _c("span", [_vm._v(_vm._s(scope.row.label))]),
                  ]
                },
              },
            ]),
          }),
          _c("vxe-column", { attrs: { title: "标签英文", field: "labelEn" } }),
          _c("vxe-column", { attrs: { title: "键值", field: "value" } }),
          _c("vxe-column", { attrs: { title: "排序", field: "sort" } }),
          _c("vxe-column", {
            attrs: {
              title: "操作",
              width: "250px",
              fixed: "right",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm.hasPermission("sys:dict:edit")
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.edit(scope.row.id)
                              },
                            },
                          },
                          [_vm._v(" 修改 ")]
                        )
                      : _vm._e(),
                    _c("el-divider", { attrs: { direction: "vertical" } }),
                    _vm.hasPermission("sys:dict:del")
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.del(scope.row.id)
                              },
                            },
                          },
                          [_vm._v(" 删除 ")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("dict-value-form", {
        ref: "dictValueForm",
        on: { refreshDataList: _vm.refreshList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }